$(document).ready(function () {
    // Ленивая подгрузка карты
    let map_container = document.getElementById('map_container');
    let options_map = {
        once: true,//once start, thereafter destroy listener
        passive: true,
        capture: true
    };
    $('.header_burger').on('click', start_lazy_map);
    let map_loaded = false;

    function start_lazy_map() {
        if (!map_loaded) {
            let map_block = document.getElementById('ymap_lazy');
            map_loaded = true;
            map_block.setAttribute('src', map_block.getAttribute('data-src'));
            map_block.removeAttribute('data_src');
        }
    }

    // Мобильное меню второго и третьего уровня
    $('.navigation-menu_item__accordeon').click(function () {
        $(this).parent().toggleClass('hover');
    });
});